module.exports = __webpack_public_path__ + "img/cy.6ee05341.svg";